var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schedule-container"
  }, [_c('div', {
    staticClass: "content_wrap"
  }, [_c('myImg', {
    attrs: {
      "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/banner_5_1.png"
    }
  }), _vm._v(" "), _c('my-tab', {
    attrs: {
      "tab-list": _vm.tabList,
      "activeIndex": _vm.activeIndex,
      "bread-title": _vm.breadTitle,
      "smallSize": ""
    },
    on: {
      "change": _vm.changeTab
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "show-wrap container"
  }, [(_vm.activeIndex == 0) ? _c('introduce') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 1) ? _c('schedule') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 3) ? _c('ex-map') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 2) ? _c('traffic') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 4) ? _c('ticket-way') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 5) ? _c('hotel', {
    ref: "myhotel"
  }) : _vm._e(), _vm._v(" "), (_vm.activeIndex == 6) ? _c('div', {
    staticClass: "pre-reg-wrap"
  }, [_c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoAv/link.png",
      "alt": "pre-registration QR"
    }
  }), _vm._v(" "), _c('span', [_vm._v("汽车产业链从业人士扫码登记")]), _vm._v(" "), _c('span', [_vm._v("审核通过后获邀入场")])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('page-footer')], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7414b0bf","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/schedule/index.vue
// module id = null
// module chunks = 